// Number formats for the dashboard: sizes, money, uptime and chart labels, in the active
// language (i18n/format.ts).
import { formatClock, formatDayMonth, formatHourMinute, formatUnit, formatUsd, messages } from "../i18n";

const GIB = 1024 ** 3;
const TIB = 1024 ** 4;

/** Bytes as GiB or TiB with the unit, both numbers in the same unit: [used, total, unit]. */
export function sizePair(used: number, total: number): [number, number, string] {
  const [div, unit] = total >= TIB ? [TIB, "TiB"] : [GIB, "GiB"];
  const round = (b: number) => Math.round((b / div) * (unit === "TiB" ? 100 : 10)) / (unit === "TiB" ? 100 : 10);
  return [round(used), round(total), unit];
}

export function gibOf(bytes: number): number {
  return Math.round((bytes / GIB) * 10) / 10;
}

export const usd = (n: number): string => formatUsd(n);

/** "18 days", "3 h", "5 min". */
export function uptime(seconds: number): string {
  const days = Math.floor(seconds / 86_400);
  if (days >= 1) return formatUnit(days, "day", "long");
  const hours = Math.floor(seconds / 3600);
  return hours >= 1 ? formatUnit(hours, "hour", "short") : formatUnit(Math.max(1, Math.floor(seconds / 60)), "minute", "short");
}

/** "2026-09-21" → "21 Sep"; anything else unchanged. */
export function shortDay(day: string): string {
  const d = new Date(`${day}T00:00:00`);
  return Number.isNaN(d.getTime()) ? day : formatDayMonth(d);
}

export const clock = formatClock;
export const hourMinute = formatHourMinute;

export function greeting(hour: number): string {
  const g = messages().dashboard.greeting;
  return hour < 5 ? g.evening : hour < 12 ? g.morning : hour < 18 ? g.afternoon : g.evening;
}
